var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2364 45.4092H13.5602C11.782 45.4092 10.0766 44.7028 8.81925 43.4454C7.56186 42.188 6.85547 40.4827 6.85547 38.7044V31.9997C6.85547 30.2215 7.56186 28.5161 8.81925 27.2587C10.0766 26.0013 11.782 25.2949 13.5602 25.2949H15.2364C15.681 25.2949 16.1073 25.4715 16.4217 25.7859C16.736 26.1002 16.9126 26.5266 16.9126 26.9711V43.733C16.9126 44.1776 16.736 44.6039 16.4217 44.9183C16.1073 45.2326 15.681 45.4092 15.2364 45.4092Z",
    stroke: "#6263AB",
    strokeWidth: 3.35238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4344 45.4092H48.7582C48.3137 45.4092 47.8873 45.2326 47.573 44.9183C47.2586 44.6039 47.082 44.1776 47.082 43.733V26.9711C47.082 26.5266 47.2586 26.1002 47.573 25.7859C47.8873 25.4715 48.3137 25.2949 48.7582 25.2949H50.4344C52.2126 25.2949 53.918 26.0013 55.1754 27.2587C56.4328 28.5161 57.1392 30.2215 57.1392 31.9997V38.7044C57.1392 40.4827 56.4328 42.188 55.1754 43.4454C53.918 44.7028 52.2126 45.4092 50.4344 45.4092Z",
    stroke: "#6263AB",
    strokeWidth: 3.35238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 25.2955C13.5625 20.4054 15.5051 15.7156 18.9629 12.2578C22.4207 8.8 27.1105 6.85742 32.0006 6.85742C36.8907 6.85742 41.5805 8.8 45.0383 12.2578C48.4961 15.7156 50.4387 20.4054 50.4387 25.2955",
    stroke: "#6263AB",
    strokeWidth: 3.35238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7031 53.7911H43.7317C45.5099 53.7911 47.2153 53.0847 48.4727 51.8273C49.7301 50.5699 50.4365 48.8646 50.4365 47.0863V45.4102",
    stroke: "#6263AB",
    strokeWidth: 3.35238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3493 57.1423H31.9969C31.1078 57.1423 30.2551 56.7891 29.6264 56.1604C28.9977 55.5317 28.6445 54.679 28.6445 53.7899C28.6445 52.9008 28.9977 52.0481 29.6264 51.4194C30.2551 50.7907 31.1078 50.4375 31.9969 50.4375H35.3493C36.2384 50.4375 37.0911 50.7907 37.7198 51.4194C38.3485 52.0481 38.7017 52.9008 38.7017 53.7899C38.7017 54.679 38.3485 55.5317 37.7198 56.1604C37.0911 56.7891 36.2384 57.1423 35.3493 57.1423Z",
    stroke: "#6263AB",
    strokeWidth: 3.35238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M25.293 23.6195C25.2932 22.3904 25.6313 21.1849 26.2703 20.135C26.9094 19.085 27.8247 18.2309 28.9164 17.666C30.008 17.1011 31.234 16.8472 32.4602 16.932C33.6864 17.0168 34.8657 17.437 35.8692 18.1467C36.8728 18.8565 37.6619 19.8284 38.1503 20.9563C38.6388 22.0843 38.8078 23.3248 38.6389 24.5422C38.4699 25.7597 37.9696 26.9073 37.1925 27.8597C36.4154 28.812 35.3915 29.5324 34.2327 29.9421C33.5788 30.1733 33.0127 30.6016 32.6124 31.168C32.2121 31.7344 31.9974 32.411 31.9977 33.1045V33.6766",
    stroke: "#6263AB",
    strokeWidth: 3.35238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M31.9983 40.3809C31.8325 40.3809 31.6705 40.43 31.5326 40.5221C31.3948 40.6142 31.2874 40.7451 31.224 40.8982C31.1605 41.0514 31.1439 41.2199 31.1763 41.3825C31.2086 41.545 31.2884 41.6944 31.4056 41.8116C31.5228 41.9288 31.6722 42.0086 31.8347 42.0409C31.9973 42.0733 32.1658 42.0567 32.319 41.9933C32.4721 41.9298 32.603 41.8224 32.6951 41.6846C32.7872 41.5468 32.8363 41.3847 32.8363 41.219C32.8363 40.9967 32.748 40.7835 32.5909 40.6263C32.4337 40.4692 32.2205 40.3809 31.9983 40.3809Z",
    stroke: "#6263AB",
    strokeWidth: 3.35238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqSvg);
export default __webpack_public_path__ + "static/media/faqSVG.5ad3494eee7f6987a5a9156c658c01e6.svg";
export { ForwardRef as ReactComponent };